import { CANCEL } from 'redux-saga';

import axiosInstance from './axios';

// Cancelling a saga also releases the HTTP request and its response buffer.
export const cancellableGet = (url, config = {}) => {
  const controller = new AbortController();
  const request = axiosInstance
    .get(url, { ...config, signal: controller.signal })
    .then((response) => response.data);
  request[CANCEL] = () => controller.abort();
  return request;
};
